(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompthead-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-banner-slider')) {
    customElements.define('ph-banner-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (this.slides.length < 2) return;
        this.index = 0;
        this.revision = 0;
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.controls = this.querySelector('[data-controls]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.dots = [...this.querySelectorAll('[data-go]')];
        this.controls.hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), { signal });
        this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), { signal });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i), { signal }));
        this.pauseButton.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updatePause();
          this.schedule();
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.reduced.addEventListener('change', () => {
          if (this.reduced.matches) this.paused = true;
          this.updatePause(); this.schedule();
        }, { signal });
        const track = this.querySelector('.ph-banners__slides');
        track.addEventListener('pointerdown', event => { this.start = [event.clientX, event.clientY]; this.swiped = false; }, { signal });
        track.addEventListener('pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start[0], dy = event.clientY - this.start[1];
          this.start = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4) {
            this.swiped = true; this.show(this.index + (dx < 0 ? 1 : -1));
          }
        }, { signal });
        track.addEventListener('pointercancel', () => { this.start = null; }, { signal });
        track.addEventListener('click', event => {
          if (this.swiped) { event.preventDefault(); this.swiped = false; }
        }, { signal, capture: true });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (i < 0) return;
          this.paused = true; this.updatePause(); this.show(i);
        }, { signal });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.updatePause(); this.schedule();
      }
      updatePause() {
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.paused || this.hovered || this.focused || !this.inView || document.hidden) return;
        this.timer = setTimeout(() => this.show(this.index + 1, false), Number(this.dataset.interval) || 6000);
      }
      async show(target, manual = true) {
        clearTimeout(this.timer);
        const revision = ++this.revision;
        const next = (target + this.slides.length) % this.slides.length;
        const image = this.slides[next].querySelector('img');
        if (image) {
          image.loading = 'eager';
          try { await image.decode(); } catch {}
        }
        if (!this.isConnected || revision !== this.revision) return;
        const oldSlide = this.slides[this.index], newSlide = this.slides[next];
        const focusInside = oldSlide.contains(document.activeElement);
        this.slides.forEach((slide, i) => { slide.hidden = i !== next; slide.inert = i !== next; });
        this.index = next;
        this.dots.forEach((dot, i) => { if (i === next) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        if (focusInside) newSlide.querySelector('a').focus({ preventScroll: true });
        if (!this.reduced.matches && oldSlide !== newSlide) newSlide.animate([{ opacity: 0.5 }, { opacity: 1 }], { duration: 280 });
        if (manual) {
          const status = this.querySelector('[data-status]');
          status.textContent = status.dataset.template.replace('__CURRENT__', next + 1);
        }
        this.schedule();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.revision++;
        this.abort?.abort(); this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
